<template>
    <div>
        <div>
            <div class="grid sm:grid-cols-2 gap-x-10">
                <div class="">
                    <h1 class="text-xl font-bold mb-2">{{ $t('tracking_links.p[0]') }}</h1>
                    <p class="leading-relaxed block">{{ $t('tracking_links.p[1]') }}</p>
                    <br />
                    <h1 class="text-xl font-bold mb-2">{{ $t('tracking_links.p[2]') }}</h1>
                    <p class="leading-relaxed block">{{ $t('tracking_links.p[3]') }}</p>
                </div>
                <div>
                    <h3 class="text-xl font-bold mb-4 text-button dark:text-growth">{{ $t('tracking_links.p[4]') }}</h3>
                    <label for="trackingLinkName" class="block text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('tracking_links.p[5]') }}</label>
                    <input type="text" id="trackingLinkName" v-model="trackingLinkName" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                    <button type="button" @click="submit" class="bg-button text-buttonText dark:bg-growth dark:text-black rounded-lg p-2 px-4 mt-5 cursor-pointer">{{ $t('tracking_links.p[6]') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
    import { postTrackingLink } from '@/api/api';
</script>
<script>
export default {
    props: ['modelID'],
    emits: ['newLink'],
    data() {
        return {
            trackingLinkName: ''
        };
    },
    methods: {
        async submit() {
            const response = await postTrackingLink(this.$cookies.get('userToken'), this.$cookies.get('c_id'), this.modelID, this.trackingLinkName, 'tracking');
            console.log(response);
            if (response.success === true) {
                this.$emit('newLink', response.data);
            } else {
                alert("Error: " + response.message);
            }
        }
    },
};
</script>